export const roles = {
  SUPER_ADMIN: 'SuperAdmin',
  HEAD_TEACHER: 'HeadTeacher'
};
